import React from "react";

function starPoints(cx, cy, outer, inner = outer * 0.38) {
  const pts = [];
  for (let i = 0; i < 10; i += 1) {
    const angle = ((i * 36 - 90) * Math.PI) / 180;
    const radius = i % 2 === 0 ? outer : inner;
    pts.push(
      `${(cx + radius * Math.cos(angle)).toFixed(2)},${(
        cy + radius * Math.sin(angle)
      ).toFixed(2)}`
    );
  }
  return pts.join(" ");
}

function EuStars() {
  const stars = Array.from({ length: 12 }, (_, index) => {
    const angle = ((index * 30 - 90) * Math.PI) / 180;
    const cx = 16 + 9.4 * Math.cos(angle);
    const cy = 16 + 9.4 * Math.sin(angle);
    return (
      <polygon key={index} points={starPoints(cx, cy, 1.85)} fill="#FCDD09" />
    );
  });
  return (
    <svg viewBox="0 0 32 32" className="pi-plate-chip__stars" aria-hidden="true">
      {stars}
    </svg>
  );
}

function UnionJack() {
  return (
    <svg viewBox="0 0 60 36" className="pi-plate-chip__flag" aria-hidden="true">
      <clipPath id="pi-uk-flag-clip">
        <rect width="60" height="36" rx="1" />
      </clipPath>
      <g clipPath="url(#pi-uk-flag-clip)">
        <rect width="60" height="36" fill="#012169" />
        <path d="M0,0 L60,36 M60,0 L0,36" stroke="#fff" strokeWidth="11" />
        <path d="M0,0 L60,36 M60,0 L0,36" stroke="#C8102E" strokeWidth="3.5" />
        <path d="M30,0 V36 M0,18 H60" stroke="#fff" strokeWidth="12" />
        <path d="M30,0 V36 M0,18 H60" stroke="#C8102E" strokeWidth="7" />
      </g>
    </svg>
  );
}

export default function PlateCountryBadge({ code }) {
  const isUk = code === "UK";
  return (
    <span
      className={`pi-plate-chip${isUk ? " pi-plate-chip--uk" : " pi-plate-chip--ie"}`}
      aria-hidden="true"
    >
      <span className="pi-plate-chip__band">
        {isUk ? <UnionJack /> : <EuStars />}
        <span className="pi-plate-chip__code">{isUk ? "UK" : "IRL"}</span>
      </span>
      <span className="pi-plate-chip__face">
        <span className="pi-plate-chip__text">
          {isUk ? "AB12 CDE" : "191-D"}
        </span>
      </span>
    </span>
  );
}
